import React from "react";
import { ListSectionProps } from "./props";

/**
 * Primary UI component for user interaction
 */
const ListSection = ({
  html,
  section_properties,
  ul_properties,
}: ListSectionProps): React.JSX.Element => {
  return (
    <section className={"vcl-list-section"} {...section_properties}>
      <ul {...ul_properties}>
        {html.map((item, index) => (
          <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
        ))}
      </ul>
    </section>
  );
};

export default ListSection;
